<div class="w-full max-w-xs mx-auto container mt-28" >
  <form class=" shadow-lg rounded px-8 pt-6 pb-8 mb-4" [formGroup]="fGroup" (ngSubmit)="doAddProject()">
      <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="email">
              Company Name
          </label>
          <input class="input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none" id="email" type="email" formControlName="name" placeholder="Name" name="name" maxlength="50" ngModel required/>
      </div>

      <div class="mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
              link Image
              <a target="_blank" href="https://imagetolink.com/">convert your image to link</a>
          </label>
          <input class="input appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline" id="text" formControlName="imageLink" type="text" name="imageLink" ngModel required placeholder="https://"/>

      </div>




      <div class="mb-6">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
            Work Detail
        </label>
        <input class="input appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline" id="text" formControlName="description" type="text" name="description" ngModel required placeholder="work detail"/>
    </div>

      <div *ngIf="isLoading" class="flex justify-center items-center">
          <div class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full" role="status">
            <!-- <span class="visually-hidden">Loading...</span> -->
          </div>
        </div>

      <div class="cursor-not-allowed flex items-center justify-between">
          <button class='cursor-not-allowed bg-blue-500  text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ' type="submit" [disabled]="fGroup.invalid">
              <span>
                  Save
              </span>
          </button>
      </div>

  </form>
  <p class="text-center text-gray-500 text-xs">&copy;2023 Angga</p>
</div>
